{
  "schemaVersion": 2,
  "id": "roomsettings-popup",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; slicePx is source pixels",
  "sourceRoot": "repository root",
  "reference": "var/out/popups/room.png",
  "defaultState": "filled",
  "popup": {
    "place": {
      "x": 12,
      "y": 206,
      "w": 916
    },
    "height": 1368.28,
    "padding": {
      "top": 44,
      "right": 12,
      "bottom": 44,
      "left": 12
    },
    "scroll": {
      "y": 480,
      "h": 826
    }
  },
  "textContract": {
    "fontFile": "apps/client/public/fonts/Nunito-latin.woff2",
    "renderer": "Live font text, not baked into any asset.",
    "position": "Stage coordinates at scrollTop=0. Only rows and their labels, chips, badges and hit targets subtract scrollTop and clip to the scroll viewport.",
    "roles": {
      "title": {
        "font": "Nunito",
        "weight": 800,
        "size": 48,
        "lineHeight": 60,
        "trackingEm": 0
      },
      "label": {
        "font": "Nunito",
        "weight": 800,
        "size": 32,
        "lineHeight": 40,
        "trackingEm": 0.01
      },
      "chip": {
        "font": "Nunito",
        "weight": 700,
        "size": 26,
        "lineHeight": 33,
        "trackingEm": 0
      },
      "action": {
        "font": "Nunito",
        "weight": 800,
        "size": 56,
        "lineHeight": 56,
        "trackingEm": 0.01
      }
    },
    "ordinaryOverflow": "No truncation, shrinking, or wrapping within a chip word."
  },
  "colors": {
    "white": "#ffffff",
    "gold": "#ffe36a",
    "disabled": "#6f7ba8",
    "onGold": "#000000"
  },
  "pieces": {
    "frame": {
      "path": "apps/client/public/art/howto-cut/slice/panel-9slice.png",
      "pixelW": 820,
      "pixelH": 814,
      "sha256": "96dbf2463e6872c9a11f970691a4d4605d093cb03e555c35362e63ecf6f5f540",
      "reused": true
    },
    "rule": {
      "path": "apps/client/public/art/howto-cut/slice/title-rule.png",
      "pixelW": 352,
      "pixelH": 28,
      "sha256": "69bb07654abbca6f305378e60db87e901558045f9534e94a498c044d40582111",
      "reused": true
    },
    "close": {
      "path": "apps/client/public/art/ui4b/btn-close-x@2x.png",
      "pixelW": 232,
      "pixelH": 232,
      "sha256": "7fd5fd82aeacc15f679fbe74cfe7e10b3770f0b82185a02a14dd3c2287f020d3",
      "reused": true
    },
    "on": {
      "path": "apps/client/public/art/create-kit/pill.on.png",
      "pixelW": 247,
      "pixelH": 140,
      "sha256": "fe020c119da9e66c9acf92c0da5a3d57bab8f6a617716ee20eb5a7d6dbcdc0b3",
      "reused": true
    },
    "off": {
      "path": "apps/client/public/art/create-kit/pill.off.png",
      "pixelW": 247,
      "pixelH": 140,
      "sha256": "4e4c0d8bfeb8c1fcaabb2a0cb9f02c3979a9a723a189da8df7ebaab469d32cb2",
      "reused": true
    },
    "badge": {
      "path": "apps/client/public/art/create-kit/k18.badge.png",
      "pixelW": 152,
      "pixelH": 152,
      "sha256": "6ec66aa7bcc341c134a8e839faf3be9ced5f679b1c39c1c09193a115dc5ef50a",
      "reused": true
    },
    "cta": {
      "path": "apps/client/public/art/lobby-kit/cta.plate.png",
      "pixelW": 1736,
      "pixelH": 326,
      "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde",
      "reused": true
    },
    "palm.tl": {
      "path": "apps/client/public/art/howto-cut/slice/palm-tl.png",
      "pixelW": 246,
      "pixelH": 222,
      "sha256": "b0fd25d7941794c9a457ee37d56f4f3b84486eb0854b3af932c271daa42119c3",
      "reused": true
    },
    "palm.tr": {
      "path": "apps/client/public/art/howto-cut/slice/palm-tr.png",
      "pixelW": 246,
      "pixelH": 222,
      "sha256": "717c8bf532a6ea7f0605b7cd94742b73d2cdc9afbddf22964b9e5cfec8c7d82d",
      "reused": true
    },
    "palm.bl": {
      "path": "apps/client/public/art/howto-cut/slice/palm-bl.png",
      "pixelW": 246,
      "pixelH": 222,
      "sha256": "0a338736cfed2fb14eeb9df5a500d9612cf372d379e2b67b9b4ad0bbb818cbe0",
      "reused": true
    },
    "palm.br": {
      "path": "apps/client/public/art/howto-cut/slice/palm-br.png",
      "pixelW": 246,
      "pixelH": 222,
      "sha256": "76bf41ca7d8c5860e47ef547671a69ce18ed46a4754de858e43a42b7bdada0be",
      "reused": true
    }
  },
  "elements": [
    {
      "id": "popup.frame",
      "piece": "apps/client/public/art/howto-cut/slice/panel-9slice.png",
      "x": 12,
      "y": 206,
      "w": 916,
      "h": 1368.28,
      "z": 60,
      "render": "border-image",
      "slicePx": {
        "top": 58,
        "right": 58,
        "bottom": 58,
        "left": 58
      },
      "borderWidth": 58,
      "fill": true
    },
    {
      "id": "popup.palm.tl",
      "piece": "apps/client/public/art/howto-cut/slice/palm-tl.png",
      "x": 12,
      "y": 206,
      "w": 246,
      "h": 222,
      "z": 61,
      "render": "image"
    },
    {
      "id": "popup.palm.tr",
      "piece": "apps/client/public/art/howto-cut/slice/palm-tr.png",
      "x": 682,
      "y": 206,
      "w": 246,
      "h": 222,
      "z": 61,
      "render": "image"
    },
    {
      "id": "popup.palm.bl",
      "piece": "apps/client/public/art/howto-cut/slice/palm-bl.png",
      "x": 12,
      "y": 1352.28,
      "w": 246,
      "h": 222,
      "z": 61,
      "render": "image"
    },
    {
      "id": "popup.palm.br",
      "piece": "apps/client/public/art/howto-cut/slice/palm-br.png",
      "x": 682,
      "y": 1352.28,
      "w": 246,
      "h": 222,
      "z": 61,
      "render": "image"
    },
    {
      "id": "popup.rule",
      "piece": "apps/client/public/art/howto-cut/slice/title-rule.png",
      "x": 294,
      "y": 432,
      "w": 352,
      "h": 28,
      "z": 62,
      "render": "image"
    },
    {
      "id": "popup.close",
      "piece": "apps/client/public/art/ui4b/btn-close-x@2x.png",
      "x": 752,
      "y": 242,
      "w": 140,
      "h": 140,
      "z": 66,
      "render": "image"
    },
    {
      "id": "chip.seats.3",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 532,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.seats.3"
    },
    {
      "id": "chip.seats.4",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 279,
      "y": 532,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.seats.4"
    },
    {
      "id": "chip.seats.5",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 476,
      "y": 532,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.seats.5"
    },
    {
      "id": "chip.seats.6",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 673,
      "y": 532,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.seats.6"
    },
    {
      "id": "chip.rounds.1",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 692,
      "w": 250.66666666666666,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.rounds.1"
    },
    {
      "id": "chip.rounds.2",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 344.66666666666663,
      "y": 692,
      "w": 250.66666666666666,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.rounds.2"
    },
    {
      "id": "chip.rounds.3",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 607.3333333333333,
      "y": 692,
      "w": 250.66666666666666,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.rounds.3"
    },
    {
      "id": "chip.pace.chill",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 852,
      "w": 382,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.pace.chill"
    },
    {
      "id": "chip.pace.quick",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 476,
      "y": 852,
      "w": 382,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.pace.quick"
    },
    {
      "id": "chip.vibe.friendly",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 1012,
      "w": 382,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.vibe.friendly"
    },
    {
      "id": "chip.vibe.bolder",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 476,
      "y": 1012,
      "w": 382,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.vibe.bolder"
    },
    {
      "id": "badge.bolder",
      "piece": "apps/client/public/art/create-kit/k18.badge.png",
      "x": 782,
      "y": 968,
      "w": 76,
      "h": 76,
      "z": 65,
      "render": "image",
      "scrolls": true,
      "parent": "chip.vibe.bolder",
      "anchor": {
        "point": "pill image top-right",
        "dx": -76,
        "dy": -44
      },
      "pointerEvents": "none"
    },
    {
      "id": "chip.vibe.flirty",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 1148,
      "w": 382,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.vibe.flirty"
    },
    {
      "id": "chip.vibe.naughty",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 476,
      "y": 1148,
      "w": 382,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.vibe.naughty"
    },
    {
      "id": "badge.naughty",
      "piece": "apps/client/public/art/create-kit/k18.badge.png",
      "x": 782,
      "y": 1104,
      "w": 76,
      "h": 76,
      "z": 65,
      "render": "image",
      "scrolls": true,
      "parent": "chip.vibe.naughty",
      "anchor": {
        "point": "pill image top-right",
        "dx": -76,
        "dy": -44
      },
      "pointerEvents": "none"
    },
    {
      "id": "chip.who.open",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 1308,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.who.open"
    },
    {
      "id": "chip.who.women",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 279,
      "y": 1308,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.who.women"
    },
    {
      "id": "chip.who.men",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 476,
      "y": 1308,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.who.men"
    },
    {
      "id": "chip.who.mix",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 673,
      "y": 1308,
      "w": 185,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.who.mix"
    },
    {
      "id": "chip.visibility.link",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 82,
      "y": 1468,
      "w": 250.66666666666666,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.visibility.link"
    },
    {
      "id": "chip.visibility.friends",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 344.66666666666663,
      "y": 1468,
      "w": 250.66666666666666,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.visibility.friends"
    },
    {
      "id": "chip.visibility.public",
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "x": 607.3333333333333,
      "y": 1468,
      "w": 250.66666666666666,
      "h": 76,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "capRule": "height * source slice / source height = 76 * 84 / 140 = 45.6",
      "sourceSize": {
        "w": 247,
        "h": 140
      },
      "scrolls": true,
      "parent": "chip.visibility.public"
    },
    {
      "id": "done",
      "piece": "apps/client/public/art/lobby-kit/cta.plate.png",
      "x": 82,
      "y": 1346,
      "w": 776,
      "h": 126.28,
      "z": 62,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      },
      "sourceSize": {
        "w": 1736,
        "h": 326
      },
      "capRule": "126.28 * 331 / 326 = 128.21680981595092"
    }
  ],
  "texts": [
    {
      "id": "popup.title",
      "role": "title",
      "text": "ROOM SETTINGS",
      "x": 82,
      "y": 330,
      "w": 776,
      "h": 60,
      "size": 48,
      "align": "center",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff"
    },
    {
      "id": "seats.label",
      "role": "label",
      "text": "SEATS",
      "x": 82,
      "y": 480,
      "w": 776,
      "h": 40,
      "size": 32,
      "align": "left",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true
    },
    {
      "id": "chip.seats.3.label",
      "role": "chip",
      "text": "3",
      "x": 120,
      "y": 555.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.seats.3",
      "capCenterY": 572,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.seats.4.label",
      "role": "chip",
      "text": "4",
      "x": 317,
      "y": 555.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.seats.4",
      "capCenterY": 572,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.seats.5.label",
      "role": "chip",
      "text": "5",
      "x": 514,
      "y": 555.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.seats.5",
      "capCenterY": 572,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.seats.6.label",
      "role": "chip",
      "text": "6",
      "x": 711,
      "y": 555.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.seats.6",
      "capCenterY": 572,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "rounds.label",
      "role": "label",
      "text": "ROUNDS",
      "x": 82,
      "y": 640,
      "w": 776,
      "h": 40,
      "size": 32,
      "align": "left",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true
    },
    {
      "id": "chip.rounds.1.label",
      "role": "chip",
      "text": "1",
      "x": 120,
      "y": 715.5,
      "w": 174.66666666666666,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.rounds.1",
      "capCenterY": 732,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.rounds.2.label",
      "role": "chip",
      "text": "2",
      "x": 382.66666666666663,
      "y": 715.5,
      "w": 174.66666666666666,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.rounds.2",
      "capCenterY": 732,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.rounds.3.label",
      "role": "chip",
      "text": "3",
      "x": 645.3333333333333,
      "y": 715.5,
      "w": 174.66666666666666,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.rounds.3",
      "capCenterY": 732,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "pace.label",
      "role": "label",
      "text": "PACE",
      "x": 82,
      "y": 800,
      "w": 776,
      "h": 40,
      "size": 32,
      "align": "left",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true
    },
    {
      "id": "chip.pace.chill.label",
      "role": "chip",
      "text": "CHILL",
      "x": 120,
      "y": 875.5,
      "w": 306,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.pace.chill",
      "capCenterY": 892,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.pace.quick.label",
      "role": "chip",
      "text": "QUICK",
      "x": 514,
      "y": 875.5,
      "w": 306,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.pace.quick",
      "capCenterY": 892,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "vibe.label",
      "role": "label",
      "text": "VIBE",
      "x": 82,
      "y": 960,
      "w": 776,
      "h": 40,
      "size": 32,
      "align": "left",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true
    },
    {
      "id": "chip.vibe.friendly.label",
      "role": "chip",
      "text": "FRIENDLY",
      "x": 120,
      "y": 1035.5,
      "w": 306,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.vibe.friendly",
      "capCenterY": 1052,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.vibe.bolder.label",
      "role": "chip",
      "text": "BOLDER",
      "x": 514,
      "y": 1035.5,
      "w": 306,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.vibe.bolder",
      "capCenterY": 1052,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.vibe.flirty.label",
      "role": "chip",
      "text": "FLIRTY",
      "x": 120,
      "y": 1171.5,
      "w": 306,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.vibe.flirty",
      "capCenterY": 1188,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.vibe.naughty.label",
      "role": "chip",
      "text": "NAUGHTY",
      "x": 514,
      "y": 1171.5,
      "w": 306,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.vibe.naughty",
      "capCenterY": 1188,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "who.label",
      "role": "label",
      "text": "WHO CAN JOIN",
      "x": 82,
      "y": 1256,
      "w": 776,
      "h": 40,
      "size": 32,
      "align": "left",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true
    },
    {
      "id": "chip.who.open.label",
      "role": "chip",
      "text": "OPEN",
      "x": 120,
      "y": 1331.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.who.open",
      "capCenterY": 1348,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.who.women.label",
      "role": "chip",
      "text": "WOMEN",
      "x": 317,
      "y": 1331.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.who.women",
      "capCenterY": 1348,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.who.men.label",
      "role": "chip",
      "text": "MEN",
      "x": 514,
      "y": 1331.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.who.men",
      "capCenterY": 1348,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.who.mix.label",
      "role": "chip",
      "text": "MIX",
      "x": 711,
      "y": 1331.5,
      "w": 109,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.who.mix",
      "capCenterY": 1348,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "visibility.label",
      "role": "label",
      "text": "VISIBILITY",
      "x": 82,
      "y": 1416,
      "w": 776,
      "h": 40,
      "size": 32,
      "align": "left",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true
    },
    {
      "id": "chip.visibility.link.label",
      "role": "chip",
      "text": "LINK",
      "x": 120,
      "y": 1491.5,
      "w": 174.66666666666666,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.visibility.link",
      "capCenterY": 1508,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.visibility.friends.label",
      "role": "chip",
      "text": "FRIENDS",
      "x": 382.66666666666663,
      "y": 1491.5,
      "w": 174.66666666666666,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.visibility.friends",
      "capCenterY": 1508,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "chip.visibility.public.label",
      "role": "chip",
      "text": "PUBLIC",
      "x": 645.3333333333333,
      "y": 1491.5,
      "w": 174.66666666666666,
      "h": 33,
      "size": 26,
      "align": "center",
      "font": "Nunito",
      "weight": 700,
      "trackingEm": 0,
      "z": 64,
      "color": "#ffffff",
      "scrolls": true,
      "parent": "chip.visibility.public",
      "capCenterY": 1508,
      "paddingFromInnerEdge": 16
    },
    {
      "id": "done.label",
      "role": "action",
      "text": "DONE",
      "x": 82,
      "y": 1381.14,
      "w": 776,
      "h": 56,
      "size": 56,
      "align": "center",
      "font": "Nunito",
      "weight": 800,
      "trackingEm": 0.01,
      "z": 64,
      "color": "#000000"
    }
  ],
  "hitTargets": [
    {
      "id": "popup.close",
      "x": 764,
      "y": 254,
      "w": 116,
      "h": 116,
      "ariaLabel": "Close",
      "action": "close"
    },
    {
      "id": "chip.seats.3",
      "x": 82,
      "y": 512,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "SEATS: 3",
      "ariaChecked": true,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.seats.4",
      "x": 279,
      "y": 512,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "SEATS: 4",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.seats.5",
      "x": 476,
      "y": 512,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "SEATS: 5",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.seats.6",
      "x": 673,
      "y": 512,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "SEATS: 6",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.rounds.1",
      "x": 82,
      "y": 672,
      "w": 250.66666666666666,
      "h": 116,
      "role": "radio",
      "ariaLabel": "ROUNDS: 1",
      "ariaChecked": true,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.rounds.2",
      "x": 344.66666666666663,
      "y": 672,
      "w": 250.66666666666666,
      "h": 116,
      "role": "radio",
      "ariaLabel": "ROUNDS: 2",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.rounds.3",
      "x": 607.3333333333333,
      "y": 672,
      "w": 250.66666666666666,
      "h": 116,
      "role": "radio",
      "ariaLabel": "ROUNDS: 3",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.pace.chill",
      "x": 82,
      "y": 832,
      "w": 382,
      "h": 116,
      "role": "radio",
      "ariaLabel": "PACE: CHILL",
      "ariaChecked": true,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.pace.quick",
      "x": 476,
      "y": 832,
      "w": 382,
      "h": 116,
      "role": "radio",
      "ariaLabel": "PACE: QUICK",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.vibe.friendly",
      "x": 82,
      "y": 992,
      "w": 382,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VIBE: FRIENDLY",
      "ariaChecked": true,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.vibe.bolder",
      "x": 476,
      "y": 992,
      "w": 382,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VIBE: BOLDER",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.vibe.flirty",
      "x": 82,
      "y": 1128,
      "w": 382,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VIBE: FLIRTY",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.vibe.naughty",
      "x": 476,
      "y": 1128,
      "w": 382,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VIBE: NAUGHTY",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.who.open",
      "x": 82,
      "y": 1288,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "WHO CAN JOIN: OPEN",
      "ariaChecked": true,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.who.women",
      "x": 279,
      "y": 1288,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "WHO CAN JOIN: WOMEN",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.who.men",
      "x": 476,
      "y": 1288,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "WHO CAN JOIN: MEN",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.who.mix",
      "x": 673,
      "y": 1288,
      "w": 185,
      "h": 116,
      "role": "radio",
      "ariaLabel": "WHO CAN JOIN: MIX",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.visibility.link",
      "x": 82,
      "y": 1448,
      "w": 250.66666666666666,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VISIBILITY: LINK",
      "ariaChecked": true,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.visibility.friends",
      "x": 344.66666666666663,
      "y": 1448,
      "w": 250.66666666666666,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VISIBILITY: FRIENDS",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "chip.visibility.public",
      "x": 607.3333333333333,
      "y": 1448,
      "w": 250.66666666666666,
      "h": 116,
      "role": "radio",
      "ariaLabel": "VISIBILITY: PUBLIC",
      "ariaChecked": false,
      "enabled": true,
      "scrolls": true
    },
    {
      "id": "done",
      "x": 82,
      "y": 1346,
      "w": 776,
      "h": 126.28,
      "ariaLabel": "Done",
      "action": "close"
    }
  ],
  "seatVariants": {},
  "rows": [
    {
      "id": "seats",
      "label": "SEATS",
      "labelY": 480,
      "chipY": 532,
      "columns": 4,
      "lines": 1,
      "gapX": 12,
      "linePitch": 136,
      "rowHeight": 160,
      "chipWidth": 185,
      "chipHeight": 76
    },
    {
      "id": "rounds",
      "label": "ROUNDS",
      "labelY": 640,
      "chipY": 692,
      "columns": 3,
      "lines": 1,
      "gapX": 12,
      "linePitch": 136,
      "rowHeight": 160,
      "chipWidth": 250.66666666666666,
      "chipHeight": 76
    },
    {
      "id": "pace",
      "label": "PACE",
      "labelY": 800,
      "chipY": 852,
      "columns": 2,
      "lines": 1,
      "gapX": 12,
      "linePitch": 136,
      "rowHeight": 160,
      "chipWidth": 382,
      "chipHeight": 76
    },
    {
      "id": "vibe",
      "label": "VIBE",
      "labelY": 960,
      "chipY": 1012,
      "columns": 2,
      "lines": 2,
      "gapX": 12,
      "linePitch": 136,
      "rowHeight": 296,
      "chipWidth": 382,
      "chipHeight": 76
    },
    {
      "id": "who",
      "label": "WHO CAN JOIN",
      "labelY": 1256,
      "chipY": 1308,
      "columns": 4,
      "lines": 1,
      "gapX": 12,
      "linePitch": 136,
      "rowHeight": 160,
      "chipWidth": 185,
      "chipHeight": 76
    },
    {
      "id": "visibility",
      "label": "VISIBILITY",
      "labelY": 1416,
      "chipY": 1468,
      "columns": 3,
      "lines": 1,
      "gapX": 12,
      "linePitch": 136,
      "rowHeight": 160,
      "chipWidth": 250.66666666666666,
      "chipHeight": 76
    }
  ],
  "states": {
    "filled": {
      "elementOverrides": {
        "chip.seats.3": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.seats.4": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.5": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.6": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.1": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.rounds.2": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.3": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.pace.chill": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.pace.quick": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.friendly": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.vibe.bolder": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.flirty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.naughty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.open": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.who.women": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.men": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.link": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.visibility.friends": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.public": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.mix": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        }
      },
      "textOverrides": {
        "chip.seats.3.label": {
          "color": "#ffe36a"
        },
        "chip.seats.4.label": {
          "color": "#ffffff"
        },
        "chip.seats.5.label": {
          "color": "#ffffff"
        },
        "chip.seats.6.label": {
          "color": "#ffffff"
        },
        "chip.rounds.1.label": {
          "color": "#ffe36a"
        },
        "chip.rounds.2.label": {
          "color": "#ffffff"
        },
        "chip.rounds.3.label": {
          "color": "#ffffff"
        },
        "chip.pace.chill.label": {
          "color": "#ffe36a"
        },
        "chip.pace.quick.label": {
          "color": "#ffffff"
        },
        "chip.vibe.friendly.label": {
          "color": "#ffe36a"
        },
        "chip.vibe.bolder.label": {
          "color": "#ffffff"
        },
        "chip.vibe.flirty.label": {
          "color": "#ffffff"
        },
        "chip.vibe.naughty.label": {
          "color": "#ffffff"
        },
        "chip.who.open.label": {
          "color": "#ffe36a"
        },
        "chip.who.women.label": {
          "color": "#ffffff"
        },
        "chip.who.men.label": {
          "color": "#ffffff"
        },
        "chip.visibility.link.label": {
          "color": "#ffe36a"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff"
        },
        "chip.who.mix.label": {
          "color": "#ffffff"
        }
      },
      "hitOverrides": {
        "chip.seats.3": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.seats.4": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.5": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.6": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.1": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.rounds.2": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.3": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.pace.chill": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.pace.quick": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.friendly": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.vibe.bolder": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.flirty": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.naughty": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.open": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": true,
          "ariaChecked": false
        }
      },
      "notes": "Preview selection example; use the actual room settings in implementation, not this example as new defaults."
    },
    "empty": {
      "elementOverrides": {
        "chip.seats.3": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.4": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.5": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.6": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.1": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.2": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.3": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.pace.chill": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.pace.quick": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.friendly": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.bolder": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.flirty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.naughty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.open": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.women": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.men": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.link": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.friends": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.public": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.mix": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        }
      },
      "textOverrides": {
        "chip.seats.3.label": {
          "color": "#ffffff"
        },
        "chip.seats.4.label": {
          "color": "#ffffff"
        },
        "chip.seats.5.label": {
          "color": "#ffffff"
        },
        "chip.seats.6.label": {
          "color": "#ffffff"
        },
        "chip.rounds.1.label": {
          "color": "#ffffff"
        },
        "chip.rounds.2.label": {
          "color": "#ffffff"
        },
        "chip.rounds.3.label": {
          "color": "#ffffff"
        },
        "chip.pace.chill.label": {
          "color": "#ffffff"
        },
        "chip.pace.quick.label": {
          "color": "#ffffff"
        },
        "chip.vibe.friendly.label": {
          "color": "#ffffff"
        },
        "chip.vibe.bolder.label": {
          "color": "#ffffff"
        },
        "chip.vibe.flirty.label": {
          "color": "#ffffff"
        },
        "chip.vibe.naughty.label": {
          "color": "#ffffff"
        },
        "chip.who.open.label": {
          "color": "#ffffff"
        },
        "chip.who.women.label": {
          "color": "#ffffff"
        },
        "chip.who.men.label": {
          "color": "#ffffff"
        },
        "chip.visibility.link.label": {
          "color": "#ffffff"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff"
        },
        "chip.who.mix.label": {
          "color": "#ffffff"
        }
      },
      "hitOverrides": {
        "chip.seats.3": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.4": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.5": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.6": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.1": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.2": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.3": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.pace.chill": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.pace.quick": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.friendly": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.bolder": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.flirty": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.naughty": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.open": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.women": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.friends": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": true,
          "ariaChecked": false
        }
      },
      "notes": "No settings snapshot / no selection: geometry unchanged; do not infer or submit new defaults."
    },
    "error": {
      "elementOverrides": {
        "chip.seats.3": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.seats.4": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.5": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.6": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.1": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.rounds.2": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.3": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.pace.chill": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.pace.quick": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.friendly": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.vibe.bolder": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.flirty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.naughty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.open": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.who.women": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.men": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.link": {
          "piece": "apps/client/public/art/create-kit/pill.on.png"
        },
        "chip.visibility.friends": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.public": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.mix": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        }
      },
      "textOverrides": {
        "chip.seats.3.label": {
          "color": "#ffe36a"
        },
        "chip.seats.4.label": {
          "color": "#ffffff"
        },
        "chip.seats.5.label": {
          "color": "#ffffff"
        },
        "chip.seats.6.label": {
          "color": "#ffffff"
        },
        "chip.rounds.1.label": {
          "color": "#ffe36a"
        },
        "chip.rounds.2.label": {
          "color": "#ffffff"
        },
        "chip.rounds.3.label": {
          "color": "#ffffff"
        },
        "chip.pace.chill.label": {
          "color": "#ffe36a"
        },
        "chip.pace.quick.label": {
          "color": "#ffffff"
        },
        "chip.vibe.friendly.label": {
          "color": "#ffe36a"
        },
        "chip.vibe.bolder.label": {
          "color": "#ffffff"
        },
        "chip.vibe.flirty.label": {
          "color": "#ffffff"
        },
        "chip.vibe.naughty.label": {
          "color": "#ffffff"
        },
        "chip.who.open.label": {
          "color": "#ffe36a"
        },
        "chip.who.women.label": {
          "color": "#ffffff"
        },
        "chip.who.men.label": {
          "color": "#ffffff"
        },
        "chip.visibility.link.label": {
          "color": "#ffe36a"
        },
        "chip.visibility.friends.label": {
          "color": "#ffffff"
        },
        "chip.visibility.public.label": {
          "color": "#ffffff"
        },
        "chip.who.mix.label": {
          "color": "#ffffff"
        }
      },
      "hitOverrides": {
        "chip.seats.3": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.seats.4": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.5": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.seats.6": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.1": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.rounds.2": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.rounds.3": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.pace.chill": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.pace.quick": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.friendly": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.vibe.bolder": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.flirty": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.vibe.naughty": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.open": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": true,
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": true,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": true,
          "ariaChecked": false
        }
      },
      "notes": "Preserve current selection and geometry; use the existing error reporting behavior. No new error graphic or extra message row is part of this brief."
    },
    "disabled": {
      "elementOverrides": {
        "chip.seats.3": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.4": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.5": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.seats.6": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.1": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.2": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.rounds.3": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.pace.chill": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.pace.quick": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.friendly": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.bolder": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.flirty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.vibe.naughty": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.open": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.women": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.men": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.link": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.friends": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.visibility.public": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        },
        "chip.who.mix": {
          "piece": "apps/client/public/art/create-kit/pill.off.png"
        }
      },
      "textOverrides": {
        "chip.seats.3.label": {
          "color": "#6f7ba8"
        },
        "chip.seats.4.label": {
          "color": "#6f7ba8"
        },
        "chip.seats.5.label": {
          "color": "#6f7ba8"
        },
        "chip.seats.6.label": {
          "color": "#6f7ba8"
        },
        "chip.rounds.1.label": {
          "color": "#6f7ba8"
        },
        "chip.rounds.2.label": {
          "color": "#6f7ba8"
        },
        "chip.rounds.3.label": {
          "color": "#6f7ba8"
        },
        "chip.pace.chill.label": {
          "color": "#6f7ba8"
        },
        "chip.pace.quick.label": {
          "color": "#6f7ba8"
        },
        "chip.vibe.friendly.label": {
          "color": "#6f7ba8"
        },
        "chip.vibe.bolder.label": {
          "color": "#6f7ba8"
        },
        "chip.vibe.flirty.label": {
          "color": "#6f7ba8"
        },
        "chip.vibe.naughty.label": {
          "color": "#6f7ba8"
        },
        "chip.who.open.label": {
          "color": "#6f7ba8"
        },
        "chip.who.women.label": {
          "color": "#6f7ba8"
        },
        "chip.who.men.label": {
          "color": "#6f7ba8"
        },
        "chip.visibility.link.label": {
          "color": "#6f7ba8"
        },
        "chip.visibility.friends.label": {
          "color": "#6f7ba8"
        },
        "chip.visibility.public.label": {
          "color": "#6f7ba8"
        },
        "chip.who.mix.label": {
          "color": "#6f7ba8"
        }
      },
      "hitOverrides": {
        "chip.seats.3": {
          "enabled": false,
          "ariaChecked": true
        },
        "chip.seats.4": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.seats.5": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.seats.6": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.rounds.1": {
          "enabled": false,
          "ariaChecked": true
        },
        "chip.rounds.2": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.rounds.3": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.pace.chill": {
          "enabled": false,
          "ariaChecked": true
        },
        "chip.pace.quick": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.vibe.friendly": {
          "enabled": false,
          "ariaChecked": true
        },
        "chip.vibe.bolder": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.vibe.flirty": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.vibe.naughty": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.who.open": {
          "enabled": false,
          "ariaChecked": true
        },
        "chip.who.women": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.who.men": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.visibility.link": {
          "enabled": false,
          "ariaChecked": true
        },
        "chip.visibility.friends": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.visibility.public": {
          "enabled": false,
          "ariaChecked": false
        },
        "chip.who.mix": {
          "enabled": false,
          "ariaChecked": false
        }
      },
      "notes": "Blue pieces with dimmed words; badges unchanged. DONE and close remain available as dismissal controls."
    }
  },
  "chipStates": {
    "on": {
      "piece": "apps/client/public/art/create-kit/pill.on.png",
      "color": "#ffe36a"
    },
    "off": {
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "color": "#ffffff"
    },
    "disabled": {
      "piece": "apps/client/public/art/create-kit/pill.off.png",
      "color": "#6f7ba8"
    },
    "geometryInvariant": true,
    "badgeInvariant": true,
    "selectionAndAvailabilityIndependent": true
  },
  "scrollContract": {
    "x": 82,
    "w": 776,
    "y": 480,
    "h": 826,
    "contentHeight": 1096,
    "maxScrollTop": 270,
    "initialScrollTop": 0,
    "scope": "rows only",
    "fixed": [
      "popup.frame",
      "popup.palm.tl",
      "popup.palm.tr",
      "popup.palm.bl",
      "popup.palm.br",
      "popup.title",
      "popup.rule",
      "popup.close",
      "done",
      "done.label"
    ],
    "overscroll": "contain; underlying lobby and stage stay fixed",
    "coordinates": "All row data is in stage coordinates at scrollTop=0; displayed y = stored y - scrollTop.",
    "partialTargets": "Targets are clipped by the viewport. The 116-unit minimum is their full box, available after scrolling fully into view; do not let a clipped part receive events outside the viewport.",
    "initialFullyVisibleRows": [
      "seats",
      "rounds",
      "pace",
      "vibe"
    ],
    "initialPartialRow": "who label only; who pills start at 1308 below viewport bottom 1306",
    "finalFullyVisibleRows": [
      "pace",
      "vibe",
      "who",
      "visibility"
    ],
    "rowIcons": "none"
  },
  "notes": [
    "No icons: join and visibility have no row icons in this style; an all-text label lane keeps all six groups consistent.",
    "VIBE remains the ordered 2 \u00d7 2 group. Four equal 185-unit chips would fail the required neon-to-word margins; see verification.vibeSingleLine.",
    "The brief explicitly requests a 76-high pill image. Current layout-create.json actually has 100-high image boxes with 76-high controlBoxStage and 12 units of visual outset. This delivery follows the literal 76-high image requirement, not the older 100-high image boxes; it therefore cannot also reproduce their physical size.",
    "The mandated chip size 26 and inherited label size 32 fail the brief's 16 CSS px floor at 360 wide. Values are retained and failures recorded, never marked PASS.",
    "Only the two requested composited previews are raster outputs; all runtime artwork references existing repository PNGs. No new or modified artwork assets.",
    "No color or brightness filters; disabled state changes text color only. The existing dimmed lobby is outside the untinted popup.",
    "Revision 3: WHO CAN JOIN is OPEN / WOMEN / MEN / MIX in four columns; frame width 916, x12, horizontal padding12, lane x82..858 width776. Vertical flow and badge anchors are unchanged."
  ],
  "verification": {
    "status": "Revision 3 geometry and four-column fit pass. Inherited text-floor, historical VIBE single-line, and CREATE image-height conflicts remain recorded.",
    "readyForImplementation": false,
    "applicationCodeChanged": false,
    "newArtworkCount": 0,
    "sourceAssetsModified": false,
    "published": false,
    "fontMeasurement": {
      "file": "apps/client/public/fonts/Nunito-latin.woff2",
      "sha256": "ba344451eab25b217a165363b1982048a5e5830a0daf36577973955a04cac793",
      "engine": "FreeType variable wght=700/800, HarfBuzz shaping without hinting, 64x font scale for 1/4096-unit precision",
      "previewEngine": "FreeType + HarfBuzz; direct WOFF2 glyph rasterization at 4x, variable wght=700/800 explicitly applied; sharp raster composition",
      "fallbackFontUsed": false
    },
    "chipFit": {
      "status": "PASS",
      "minimumRequiredSideGap": 16,
      "edgeDefinition": "First inward pixel below half the neon min-RGB peak on each cap; worst inset over source rows 40..100, encompassing the complete text ink band at image height 76.",
      "pillEdges": {
        "on": {
          "sourceRows": [
            40,
            100
          ],
          "leftSourceInset": 37,
          "rightSourceInset": 40,
          "leftStageInset": 20.085714,
          "rightStageInset": 21.714286
        },
        "off": {
          "sourceRows": [
            40,
            100
          ],
          "leftSourceInset": 36,
          "rightSourceInset": 39,
          "leftStageInset": 19.542857,
          "rightStageInset": 21.171429
        }
      },
      "minimumMeasuredGap": 17.576608,
      "words": [
        {
          "id": "chip.seats.3.label",
          "text": "3",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 64.614237,
              "rightGap": 62.985665
            },
            "off": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            },
            "disabled": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            }
          },
          "pass": true
        },
        {
          "id": "chip.seats.4.label",
          "text": "4",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 64.614237,
              "rightGap": 62.985665
            },
            "off": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            },
            "disabled": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            }
          },
          "pass": true
        },
        {
          "id": "chip.seats.5.label",
          "text": "5",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 64.614237,
              "rightGap": 62.985665
            },
            "off": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            },
            "disabled": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            }
          },
          "pass": true
        },
        {
          "id": "chip.seats.6.label",
          "text": "6",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 64.614237,
              "rightGap": 62.985665
            },
            "off": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            },
            "disabled": {
              "leftGap": 65.157094,
              "rightGap": 63.528522
            }
          },
          "pass": true
        },
        {
          "id": "chip.rounds.1.label",
          "text": "1",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 250.666667,
          "states": {
            "on": {
              "leftGap": 97.447571,
              "rightGap": 95.818999
            },
            "off": {
              "leftGap": 97.990428,
              "rightGap": 96.361856
            },
            "disabled": {
              "leftGap": 97.990428,
              "rightGap": 96.361856
            }
          },
          "pass": true
        },
        {
          "id": "chip.rounds.2.label",
          "text": "2",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 250.666667,
          "states": {
            "on": {
              "leftGap": 97.447571,
              "rightGap": 95.818999
            },
            "off": {
              "leftGap": 97.990428,
              "rightGap": 96.361856
            },
            "disabled": {
              "leftGap": 97.990428,
              "rightGap": 96.361856
            }
          },
          "pass": true
        },
        {
          "id": "chip.rounds.3.label",
          "text": "3",
          "size": 26,
          "weight": 700,
          "advanceWidth": 15.600098,
          "pillWidth": 250.666667,
          "states": {
            "on": {
              "leftGap": 97.447571,
              "rightGap": 95.818999
            },
            "off": {
              "leftGap": 97.990428,
              "rightGap": 96.361856
            },
            "disabled": {
              "leftGap": 97.990428,
              "rightGap": 96.361856
            }
          },
          "pass": true
        },
        {
          "id": "chip.pace.chill.label",
          "text": "CHILL",
          "size": 26,
          "weight": 700,
          "advanceWidth": 74.333984,
          "pillWidth": 382,
          "states": {
            "on": {
              "leftGap": 133.747294,
              "rightGap": 132.118722
            },
            "off": {
              "leftGap": 134.290151,
              "rightGap": 132.661579
            },
            "disabled": {
              "leftGap": 134.290151,
              "rightGap": 132.661579
            }
          },
          "pass": true
        },
        {
          "id": "chip.pace.quick.label",
          "text": "QUICK",
          "size": 26,
          "weight": 700,
          "advanceWidth": 81.899902,
          "pillWidth": 382,
          "states": {
            "on": {
              "leftGap": 129.964335,
              "rightGap": 128.335763
            },
            "off": {
              "leftGap": 130.507192,
              "rightGap": 128.87862
            },
            "disabled": {
              "leftGap": 130.507192,
              "rightGap": 128.87862
            }
          },
          "pass": true
        },
        {
          "id": "chip.vibe.friendly.label",
          "text": "FRIENDLY",
          "size": 26,
          "weight": 700,
          "advanceWidth": 122.174316,
          "pillWidth": 382,
          "states": {
            "on": {
              "leftGap": 109.827128,
              "rightGap": 108.198556
            },
            "off": {
              "leftGap": 110.369985,
              "rightGap": 108.741413
            },
            "disabled": {
              "leftGap": 110.369985,
              "rightGap": 108.741413
            }
          },
          "pass": true
        },
        {
          "id": "chip.vibe.bolder.label",
          "text": "BOLDER",
          "size": 26,
          "weight": 700,
          "advanceWidth": 106.079834,
          "pillWidth": 382,
          "states": {
            "on": {
              "leftGap": 117.874369,
              "rightGap": 116.245797
            },
            "off": {
              "leftGap": 118.417226,
              "rightGap": 116.788654
            },
            "disabled": {
              "leftGap": 118.417226,
              "rightGap": 116.788654
            }
          },
          "pass": true
        },
        {
          "id": "chip.vibe.flirty.label",
          "text": "FLIRTY",
          "size": 26,
          "weight": 700,
          "advanceWidth": 86.424072,
          "pillWidth": 382,
          "states": {
            "on": {
              "leftGap": 127.70225,
              "rightGap": 126.073678
            },
            "off": {
              "leftGap": 128.245107,
              "rightGap": 126.616535
            },
            "disabled": {
              "leftGap": 128.245107,
              "rightGap": 126.616535
            }
          },
          "pass": true
        },
        {
          "id": "chip.vibe.naughty.label",
          "text": "NAUGHTY",
          "size": 26,
          "weight": 700,
          "advanceWidth": 129.635986,
          "pillWidth": 382,
          "states": {
            "on": {
              "leftGap": 106.096293,
              "rightGap": 104.467721
            },
            "off": {
              "leftGap": 106.63915,
              "rightGap": 105.010578
            },
            "disabled": {
              "leftGap": 106.63915,
              "rightGap": 105.010578
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.open.label",
          "text": "OPEN",
          "size": 26,
          "weight": 700,
          "advanceWidth": 72.331787,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 36.248392,
              "rightGap": 34.61982
            },
            "off": {
              "leftGap": 36.791249,
              "rightGap": 35.162677
            },
            "disabled": {
              "leftGap": 36.791249,
              "rightGap": 35.162677
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.women.label",
          "text": "WOMEN",
          "size": 26,
          "weight": 700,
          "advanceWidth": 106.418213,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 19.20518,
              "rightGap": 17.576608
            },
            "off": {
              "leftGap": 19.748037,
              "rightGap": 18.119465
            },
            "disabled": {
              "leftGap": 19.748037,
              "rightGap": 18.119465
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.men.label",
          "text": "MEN",
          "size": 26,
          "weight": 700,
          "advanceWidth": 57.538086,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 43.645243,
              "rightGap": 42.016671
            },
            "off": {
              "leftGap": 44.1881,
              "rightGap": 42.559528
            },
            "disabled": {
              "leftGap": 44.1881,
              "rightGap": 42.559528
            }
          },
          "pass": true
        },
        {
          "id": "chip.who.mix.label",
          "text": "MIX",
          "size": 26,
          "weight": 700,
          "advanceWidth": 47.37207,
          "pillWidth": 185,
          "states": {
            "on": {
              "leftGap": 48.728251,
              "rightGap": 47.099679
            },
            "off": {
              "leftGap": 49.271108,
              "rightGap": 47.642536
            },
            "disabled": {
              "leftGap": 49.271108,
              "rightGap": 47.642536
            }
          },
          "pass": true
        },
        {
          "id": "chip.visibility.link.label",
          "text": "LINK",
          "size": 26,
          "weight": 700,
          "advanceWidth": 58.682129,
          "pillWidth": 250.666667,
          "states": {
            "on": {
              "leftGap": 75.906555,
              "rightGap": 74.277983
            },
            "off": {
              "leftGap": 76.449412,
              "rightGap": 74.82084
            },
            "disabled": {
              "leftGap": 76.449412,
              "rightGap": 74.82084
            }
          },
          "pass": true
        },
        {
          "id": "chip.visibility.friends.label",
          "text": "FRIENDS",
          "size": 26,
          "weight": 700,
          "advanceWidth": 110.968018,
          "pillWidth": 250.666667,
          "states": {
            "on": {
              "leftGap": 49.763611,
              "rightGap": 48.135039
            },
            "off": {
              "leftGap": 50.306468,
              "rightGap": 48.677896
            },
            "disabled": {
              "leftGap": 50.306468,
              "rightGap": 48.677896
            }
          },
          "pass": true
        },
        {
          "id": "chip.visibility.public.label",
          "text": "PUBLIC",
          "size": 26,
          "weight": 700,
          "advanceWidth": 93.651855,
          "pillWidth": 250.666667,
          "states": {
            "on": {
              "leftGap": 58.421692,
              "rightGap": 56.79312
            },
            "off": {
              "leftGap": 58.964549,
              "rightGap": 57.335977
            },
            "disabled": {
              "leftGap": 58.964549,
              "rightGap": 57.335977
            }
          },
          "pass": true
        }
      ]
    },
    "textFloor": {
      "status": "FAIL",
      "scale360": 0.382572,
      "requiredStageSizeFor16Css": 41.822222,
      "checks": [
        {
          "id": "popup.title",
          "sizeStage": 48,
          "sizeCss360": 18.363443,
          "requiredCss": 16,
          "pass": true
        },
        {
          "id": "seats.label",
          "sizeStage": 32,
          "sizeCss360": 12.242295,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.seats.3.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.seats.4.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.seats.5.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.seats.6.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "rounds.label",
          "sizeStage": 32,
          "sizeCss360": 12.242295,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.rounds.1.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.rounds.2.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.rounds.3.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "pace.label",
          "sizeStage": 32,
          "sizeCss360": 12.242295,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.pace.chill.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.pace.quick.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "vibe.label",
          "sizeStage": 32,
          "sizeCss360": 12.242295,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.vibe.friendly.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.vibe.bolder.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.vibe.flirty.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.vibe.naughty.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "who.label",
          "sizeStage": 32,
          "sizeCss360": 12.242295,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.who.open.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.who.women.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.who.men.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.who.mix.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "visibility.label",
          "sizeStage": 32,
          "sizeCss360": 12.242295,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.visibility.link.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.visibility.friends.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "chip.visibility.public.label",
          "sizeStage": 26,
          "sizeCss360": 9.946865,
          "requiredCss": 16,
          "pass": false
        },
        {
          "id": "done.label",
          "sizeStage": 56,
          "sizeCss360": 21.424017,
          "requiredCss": 16,
          "pass": true
        }
      ],
      "failCount": 26,
      "reason": "26-unit chip words = 9.946865 CSS px; 32-unit labels = 12.242295 CSS px. These explicit sizes cannot also be >=16 CSS px."
    },
    "hitTargets": {
      "status": "PASS",
      "count": 22,
      "minWidth": 116,
      "minHeight": 116,
      "minCss360": 44.378321,
      "overlaps": [],
      "scope": "Pairwise checks within scrolling content and fixed chrome. Scroll clip y=480..1306 stays 110 below close target and 40 above DONE, so their effective target areas cannot overlap at any scroll offset.",
      "clippedTargets": "A partially visible target is clipped, and its full 116-unit height becomes available when scrolled into view.",
      "effectiveOffsetsChecked": 271
    },
    "frame": {
      "status": "PASS",
      "border": 58,
      "safeInnerBox": {
        "x": 70,
        "y": 264,
        "w": 800,
        "h": 1252.28
      },
      "contentX": [
        82,
        858
      ],
      "minimumHorizontalFrameClearance": 12,
      "titleToCloseHorizontalGap": 92.536011,
      "closeHit": {
        "x": 764,
        "y": 254,
        "w": 116,
        "h": 116
      },
      "closeImage": {
        "x": 752,
        "y": 242,
        "w": 140,
        "h": 140
      },
      "closeUnchanged": false,
      "exception": "The close and corner palms retain the template size and corner-relative placement. Only their horizontal positions follow the wider frame.",
      "closeAnchorUnchanged": true,
      "palmSizesUnchanged": true
    },
    "badges": {
      "status": "PASS",
      "size": 76,
      "dx": -76,
      "dy": -44,
      "bolderToPreviousPillVerticalGap": 40,
      "bolderToPreviousHitVerticalGap": 20,
      "naughtyToPreviousPillVerticalGap": 16,
      "naughtyToPreviousHitVerticalGap": -4,
      "naughtyToPreviousHitHorizontalGap": 0,
      "note": "NAUGHTY badge is 16 units below the previous pill image. Its top four units share the preceding hit lane, horizontally inside the same BOLDER/NAUGHTY column; decorative badge is not a target. See overlap check below.",
      "badgeHitsAreIndependent": false,
      "horizontalFrameClearance": 12
    },
    "panel": {
      "status": "PASS",
      "top": 206,
      "height": 1368.28,
      "bottom": 1574.28,
      "bottomLimit": 1600,
      "clearanceFromLimit": 25.72,
      "clearanceFromStageBottom": 97.72,
      "scrollArea": {
        "y": 480,
        "h": 826
      },
      "contentHeight": 1096,
      "maxScrollTop": 270,
      "fullyVisibleRowsAtStart": 4,
      "fullyVisibleRowsAtEnd": 4,
      "allRowsReachable": true
    },
    "vibeSingleLine": {
      "status": "FAIL",
      "requirement": "Retained historical single-line check; BRIEF-3 explicitly orders 2 \u00d7 2.",
      "minimumMeasuredWidthWith12Gaps": 782.028496,
      "minimumEqualColumnWidthWith12Gaps": 856.258232,
      "availableAtChosenPadding": 776,
      "maximumInsideBorder": 800,
      "equalColumnWidthAtChosenPadding": 185,
      "naughtyMinimumSideGap": 5.967721,
      "resolution": "Keep the explicitly ordered two pairs. Equal four-column words fail. Even individually sized centered chips need 782.028496, more than the chosen 776 lane; this is no longer claimed impossible at zero padding inside the wider frame."
    },
    "pillHeightReference": {
      "status": "CONFLICT",
      "briefImageHeight": 76,
      "actualCreateImageHeight": 100,
      "actualCreateControlHeight": 76,
      "deliveredImageHeight": 76
    },
    "noTint": {
      "status": "PASS",
      "popupFilters": [],
      "disabled": "word color only"
    },
    "preview": {
      "stage": {
        "w": 941,
        "h": 1672
      },
      "phone": {
        "w": 360,
        "h": 640
      },
      "source": "var/out/popups/room.png",
      "background": "Original dimmed lobby pixels are preserved outside the rejected panel box (53,260,831,1240). Within that box the underlying lobby is restored only from the existing Friends scene, existing slogans, logo and existing scrim, then the shared popup is composed above it. No background or component asset is saved or edited.",
      "scrollTop": 270,
      "reason": "Bottom scroll position shows the revised WHO CAN JOIN four-chip row and VISIBILITY, matching the review screenshot. Both previews use this same offset; initial runtime scrollTop remains zero."
    },
    "stateCoverage": {
      "filled": true,
      "empty": true,
      "error": true,
      "disabled": true,
      "geometryInvariant": true,
      "allChipCombinationsCheckedBySharedGeometry": true
    },
    "independentAudit": {
      "status": "PASS",
      "revision": 3,
      "schemaFieldsChecked": true,
      "existingAssetHashesMatch": true,
      "fullChipWordsFitTextLanes": true,
      "glyphInkFitsMeasuredAdvance": true,
      "effectiveTargetOverlapChecksAtScrollOffsets": 271,
      "effectiveOverlaps": 0,
      "previewDimensionsVerified": true,
      "stateGeometryUnchanged": true,
      "onlyRequestedFourOutputs": true,
      "doesNotOverrideKnownBriefConflicts": true,
      "rowsChecked": 6,
      "chipWordsChecked": 20,
      "textLanesChecked": 28,
      "hitTargetsChecked": 22,
      "fundingRemovedFromAllStates": true,
      "verticalRowPitchUnchanged": true,
      "badgeRelationsUnchanged": true,
      "closeCornerAnchorUnchanged": true,
      "palmSizesUnchanged": true,
      "applicationAndBriefHashesUnchanged": false,
      "concurrentChangesObserved": [
        "apps/client/src/ui/Eligibility.tsx"
      ],
      "applicationCodeWrittenByThisTask": false
    },
    "fourColumnRows": {
      "status": "PASS",
      "rows": [
        "seats",
        "who"
      ],
      "words": [
        "OPEN",
        "WOMEN",
        "MEN",
        "MIX"
      ],
      "frameWidth": 916,
      "paddingEachSide": 12,
      "contentWidth": 776,
      "gap": 12,
      "chipWidth": 185,
      "womenAdvance": 106.418213,
      "womenMinimumGap": 17.576608,
      "minimumCenteredChipWidthForWomen": 181.846785,
      "minimumCenteredLaneWidthForWomen": 763.38714,
      "minimumLaneWith38TextInsets": 765.672852
    }
  },
  "dateVariant": {
    "reference": "BRIEF-4.md",
    "appliesTo": "Date room (Friends lobby with exactly two seats)",
    "mergeContract": {
      "schema": "Same elementOverrides / textOverrides / hitOverrides maps keyed by existing id as states. Null removes the entry, including its semantics and events.",
      "order": [
        "base elements/texts/hitTargets",
        "base states[state]",
        "dateVariant elementOverrides/textOverrides/hitOverrides",
        "dateVariant.states[state]"
      ],
      "ids": "Ids are stable layout slots; do not parse their suffix as the Date setting value. Use bindings below.",
      "rows": "Retain all base row heights and positions. SEATS has one fixed display; do not regenerate its four base columns."
    },
    "bindings": {
      "seats": {
        "value": 2,
        "fixed": true,
        "elementId": "chip.seats.3",
        "textId": "chip.seats.3.label",
        "hitTargetId": null,
        "box": {
          "x": 377.5,
          "y": 532,
          "w": 185,
          "h": 76
        },
        "placement": "Centred at x470 in lane x82..858; same 185 by 76 pill as one base SEATS column. Gold in every state; not a selectable or disabled radio."
      },
      "rounds": {
        "valuesById": {
          "chip.rounds.1": 2,
          "chip.rounds.2": 4,
          "chip.rounds.3": 6
        },
        "defaultValue": 6,
        "defaultId": "chip.rounds.3"
      },
      "vibe": {
        "valuesById": {
          "chip.vibe.friendly": "DATING",
          "chip.vibe.bolder": "BOLDER",
          "chip.vibe.flirty": "FLIRTY",
          "chip.vibe.naughty": "NAUGHTY"
        }
      }
    },
    "elementOverrides": {
      "chip.seats.3": {
        "x": 377.5,
        "piece": "apps/client/public/art/create-kit/pill.on.png",
        "pointerEvents": "none"
      },
      "chip.seats.4": null,
      "chip.seats.5": null,
      "chip.seats.6": null
    },
    "textOverrides": {
      "chip.seats.3.label": {
        "text": "2",
        "x": 415.5,
        "color": "#ffe36a"
      },
      "chip.seats.4.label": null,
      "chip.seats.5.label": null,
      "chip.seats.6.label": null,
      "chip.rounds.1.label": {
        "text": "2"
      },
      "chip.rounds.2.label": {
        "text": "4"
      },
      "chip.rounds.3.label": {
        "text": "6"
      },
      "chip.vibe.friendly.label": {
        "text": "DATING"
      }
    },
    "hitOverrides": {
      "chip.seats.3": null,
      "chip.seats.4": null,
      "chip.seats.5": null,
      "chip.seats.6": null,
      "chip.rounds.1": {
        "ariaLabel": "ROUNDS: 2"
      },
      "chip.rounds.2": {
        "ariaLabel": "ROUNDS: 4"
      },
      "chip.rounds.3": {
        "ariaLabel": "ROUNDS: 6"
      },
      "chip.vibe.friendly": {
        "ariaLabel": "VIBE: DATING"
      }
    },
    "states": {
      "filled": {
        "elementOverrides": {
          "chip.rounds.1": {
            "piece": "apps/client/public/art/create-kit/pill.off.png"
          },
          "chip.rounds.3": {
            "piece": "apps/client/public/art/create-kit/pill.on.png"
          }
        },
        "textOverrides": {
          "chip.rounds.1.label": {
            "color": "#ffffff"
          },
          "chip.rounds.3.label": {
            "color": "#ffe36a"
          }
        },
        "hitOverrides": {
          "chip.rounds.1": {
            "ariaChecked": false
          },
          "chip.rounds.3": {
            "ariaChecked": true
          }
        }
      },
      "empty": {
        "elementOverrides": {},
        "textOverrides": {},
        "hitOverrides": {}
      },
      "error": {
        "elementOverrides": {
          "chip.rounds.1": {
            "piece": "apps/client/public/art/create-kit/pill.off.png"
          },
          "chip.rounds.3": {
            "piece": "apps/client/public/art/create-kit/pill.on.png"
          }
        },
        "textOverrides": {
          "chip.rounds.1.label": {
            "color": "#ffffff"
          },
          "chip.rounds.3.label": {
            "color": "#ffe36a"
          }
        },
        "hitOverrides": {
          "chip.rounds.1": {
            "ariaChecked": false
          },
          "chip.rounds.3": {
            "ariaChecked": true
          }
        }
      },
      "disabled": {
        "elementOverrides": {},
        "textOverrides": {},
        "hitOverrides": {
          "chip.rounds.1": {
            "ariaChecked": false
          },
          "chip.rounds.3": {
            "ariaChecked": true
          }
        }
      }
    },
    "preview": {
      "file": "preview/LAYOUT-roomsettings-date.png",
      "w": 941,
      "h": 1672,
      "state": "filled",
      "scrollTop": 0,
      "reference": "var/out/popups/room.png",
      "background": "Original dimmed lobby pixels are preserved outside the rejected panel box (53,260,831,1240). Within that box the underlying lobby is restored only from the existing Friends scene, existing slogans, logo and existing scrim, then the shared popup is composed above it. No background or component asset is saved or edited.",
      "reason": "Initial scroll position shows fixed SEATS 2, ROUNDS 2/4/6 with 6 selected, and DATING. The base inner scroll range remains 0..270."
    },
    "notes": [
      "WHO CAN JOIN, VISIBILITY, PACE, DONE, title, SEATS label, frame, badge anchors and scroll inherit revision 3 without changes.",
      "Actual room selections and eligibility override the example selection. Default rounds is 6; empty still has no round selection. Error preserves the current selection. Fixed SEATS 2 remains gold and has no target in all four states.",
      "Base verification describes revision 3. The checks below cover this additive Date variant and do not supersede the recorded text-floor or pill-height conflicts."
    ],
    "verification": {
      "status": "PASS for Date deltas; inherited revision 3 conflicts remain",
      "fontMeasurement": {
        "file": "apps/client/public/fonts/Nunito-latin.woff2",
        "sha256": "ba344451eab25b217a165363b1982048a5e5830a0daf36577973955a04cac793",
        "engine": "FreeType variable wght=700/800, HarfBuzz shaping without hinting, 64x font scale for 1/4096-unit precision",
        "previewEngine": "FreeType + HarfBuzz; direct WOFF2 glyph rasterization at 4x, variable wght=700/800 explicitly applied; sharp raster composition",
        "fallbackFontUsed": false
      },
      "chipFit": {
        "status": "PASS",
        "minimumRequiredSideGap": 16,
        "edgeMeasurement": "Reuse revision 3 source neon insets on unchanged pill assets: on 37/40, off 36/39 source px, scaled by 76/140. Font words freshly shaped.",
        "words": [
          {
            "id": "chip.seats.3.label",
            "text": "2",
            "size": 26,
            "weight": 700,
            "advanceWidth": 15.60009765625,
            "textLaneWidth": 109,
            "pillWidth": 185,
            "states": {
              "on": {
                "leftGap": 64.614237,
                "rightGap": 62.985665
              }
            },
            "pass": true
          },
          {
            "id": "chip.vibe.friendly.label",
            "text": "DATING",
            "size": 26,
            "weight": 700,
            "advanceWidth": 98.80029296875,
            "textLaneWidth": 306,
            "pillWidth": 382,
            "states": {
              "on": {
                "leftGap": 121.514139,
                "rightGap": 119.885568
              },
              "off": {
                "leftGap": 122.056996,
                "rightGap": 120.428425
              },
              "disabled": {
                "leftGap": 122.056996,
                "rightGap": 120.428425
              }
            },
            "pass": true
          },
          {
            "id": "chip.rounds.1.label",
            "text": "2",
            "size": 26,
            "weight": 700,
            "advanceWidth": 15.60009765625,
            "textLaneWidth": 174.66666666666666,
            "pillWidth": 250.66666666666666,
            "states": {
              "on": {
                "leftGap": 97.44757,
                "rightGap": 95.818999
              },
              "off": {
                "leftGap": 97.990427,
                "rightGap": 96.361856
              },
              "disabled": {
                "leftGap": 97.990427,
                "rightGap": 96.361856
              }
            },
            "pass": true
          },
          {
            "id": "chip.rounds.2.label",
            "text": "4",
            "size": 26,
            "weight": 700,
            "advanceWidth": 15.60009765625,
            "textLaneWidth": 174.66666666666666,
            "pillWidth": 250.66666666666666,
            "states": {
              "on": {
                "leftGap": 97.44757,
                "rightGap": 95.818999
              },
              "off": {
                "leftGap": 97.990427,
                "rightGap": 96.361856
              },
              "disabled": {
                "leftGap": 97.990427,
                "rightGap": 96.361856
              }
            },
            "pass": true
          },
          {
            "id": "chip.rounds.3.label",
            "text": "6",
            "size": 26,
            "weight": 700,
            "advanceWidth": 15.60009765625,
            "textLaneWidth": 174.66666666666666,
            "pillWidth": 250.66666666666666,
            "states": {
              "on": {
                "leftGap": 97.44757,
                "rightGap": 95.818999
              },
              "off": {
                "leftGap": 97.990427,
                "rightGap": 96.361856
              },
              "disabled": {
                "leftGap": 97.990427,
                "rightGap": 96.361856
              }
            },
            "pass": true
          }
        ]
      },
      "stateCoverage": [
        "filled",
        "empty",
        "error",
        "disabled"
      ],
      "fixedSeatsCount": 1,
      "seatHitTargets": 0,
      "remainingHitTargets": 18,
      "unchangedOutsideDateRows": true,
      "baseLayoutUnchanged": true
    }
  }
}
